import { render, staticRenderFns } from "./quickSearch.vue?vue&type=template&id=a1920fe0&scoped=true&"
import script from "./quickSearch.vue?vue&type=script&lang=js&"
export * from "./quickSearch.vue?vue&type=script&lang=js&"
import style0 from "./quickSearch.vue?vue&type=style&index=0&id=a1920fe0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1920fe0",
  null
  
)

export default component.exports